export default "__VITE_ASSET__gsxdQ6zu__"